var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page',{attrs:{"name":"Coupon","plural":"Coupons","use":"_id","display":_vm.display,"page-prefix":"/blade/coupons","fetch":_vm.getCoupons,"remove":_vm.deleteCoupon,"sort-options":_vm.sortOptions,"sort-functions":_vm.sortFunctions,"default-sort":_vm.defaultSort}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e5520e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/CouponList.vue
// module id = null
// module chunks = 